// Shared utility functions

/**
 * Returns Material UI color based on client status
 */
export const getStatusColor = (status) => {
    switch (status) {
        case 'Online': return 'success';
        case 'Offline': return 'default';
        default: return 'warning';
    }
};

/**
 * Format date strings with special handling for zero time
 */
export const formatDate = (dateString) => {
    if (!dateString || dateString === '0001-01-01T00:00:00Z') {
         return 'Never'; // Handle zero time
    }
    try {
        return new Date(dateString).toLocaleString();
    } catch (e) {
        return 'Invalid Date';
    }
};

/**
 * Detect if system prefers dark mode
 */
export const detectSystemPrefersDarkMode = () => {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
};

/**
 * Get CSS color for status indicator with consideration for theme mode
 */
export const getStatusIndicatorColor = (status, mode = 'light') => {
    if (mode === 'dark') {
        switch (status) {
            case 'Online': return 'rgba(102, 187, 106, 1)'; // Slightly brighter green in dark mode
            case 'Offline': return 'rgba(117, 117, 117, 1)'; // Mid-grey for dark mode
            default: return 'rgba(255, 183, 77, 1)'; // Brighter warning for dark mode
        }
    } else {
        switch (status) {
            case 'Online': return 'rgba(76, 175, 80, 1)'; // Standard green
            case 'Offline': return 'rgba(158, 158, 158, 1)'; // Standard grey
            default: return 'rgba(255, 152, 0, 1)'; // Standard warning orange
        }
    }
};
